import { cafeGallerySettingKeys } from "./cafe-about";
import { readSidebarArtwork } from "./sidebar-props";

export const settingsSectionLabels = {
  details: "Café details", branding: "Branding", gallery: "About us", appearance: "Appearance",
  maps: "Google Maps", google: "Google Sign-in", email: "Email", tables: "Table QR Codes"
} as const;
export type SettingsSectionId = keyof typeof settingsSectionLabels;

const fields: Record<SettingsSectionId, readonly string[]> = {
  details: ["cafe_name", "currency", "reward_points_per_currency", "service_note"],
  branding: ["topbar_image_url", "brand_image_url"],
  gallery: cafeGallerySettingKeys,
  appearance: ["ui_theme", "sidebar_prop", "artwork_library"],
  maps: ["google_maps_api_key"],
  google: ["google_client_id"],
  email: ["resend_api_key", "resend_from_email"],
  tables: ["table_count"]
};

export function settingsSectionPayload(form: FormData, section: SettingsSectionId): Record<string, string | boolean> {
  if (section === "gallery" && form.get("cafe_gallery_uploading") === "true") throw new Error("Please wait for gallery photos to finish uploading before saving.");
  if (section === "appearance" && form.get("artwork_uploading") === "true") throw new Error("Please wait for artworks to finish uploading before saving.");
  const payload: Record<string, string | boolean> = Object.fromEntries(fields[section].map(key => [key, String(form.get(key) ?? "")]));
  for (const key of ["brand_image_url", "google_maps_api_key", "google_client_id", "resend_api_key", "resend_from_email"]) if (key in payload) payload[key] = String(payload[key]).trim();
  if (section === "appearance") payload.sidebar_prop = readSidebarArtwork({ artwork_library: String(payload.artwork_library), sidebar_prop: String(payload.sidebar_prop) })?.id || "none";
  if (section === "maps") payload.clear_google_maps_api_key = form.get("clear_google_maps_api_key") === "on";
  if (section === "email") payload.clear_resend_api_key = form.get("clear_resend_api_key") === "on";
  return payload;
}
